var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { BASE_BORDER_WIDTH, SHADOWS_NORMAL, createUIElement } from "../helpers";
import { calcWidth } from "../helpers/styles";
var StyledMenu = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    box-sizing: border-box;\n    outline: none;\n    display: inline-block;\n\n    white-space: nowrap;\n    background-color: #fff;\n\n    border-width: ", ";\n    border-style: solid;\n    border-color: ", ";\n\n    box-shadow: ", ";\n\n    min-width: 120px;\n\n    ", "\n"], ["\n    box-sizing: border-box;\n    outline: none;\n    display: inline-block;\n\n    white-space: nowrap;\n    background-color: #fff;\n\n    border-width: ", ";\n    border-style: solid;\n    border-color: ", ";\n\n    box-shadow: ", ";\n\n    min-width: 120px;\n\n    ",
    "\n"])), BASE_BORDER_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.colorPopupBorderAccent;
}, SHADOWS_NORMAL, function (_a) {
    var widthSize = _a.widthSize;
    return widthSize && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            width: ", ";\n        "], ["\n            width: ", ";\n        "])), typeof widthSize === 'string' ? widthSize : calcWidth(widthSize));
});
export var Menu = createUIElement('Menu', function (_a, ref) {
    var className = _a.className, widthSize = _a.widthSize, children = _a.children, tabIndex = _a.tabIndex, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "widthSize", "children", "tabIndex", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (React.createElement(StyledMenu, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'menu', className: "vm-Menu " + className, widthSize: widthSize, tabIndex: tabIndex, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }), children));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=Menu.js.map